import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { VwCommissionPanelModel } from 'src/app/model/vw-commission-panel.model';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { VwCommissionPanelService } from 'src/oldApp/services/vw-commission-panel.service';

@Component({
  selector: 'app-modal-vw-commission-panel',
  templateUrl: './modal-vw-commission-panel.component.html',
  styleUrls: ['./modal-vw-commission-panel.component.css']
})
export class ModalVwCommissionPanelComponent implements OnInit {
  @Input() items:VwCommissionPanelModel[];
  @Input() page:string;
  @Input() mode:string;
  @Input() commissionGroup:number;

  // estado pagina
  public viewStatus:number=0;
  public formIsLocked:boolean=false;
  public oldSchema:number=0;
  public selectedSchemaId:number=0;
  public selectedSchema:CatalogModel=new CatalogModel();
  public selectedCategory:CatalogModel=new CatalogModel();
  public commission:number=null;
  public active:boolean=true;
  public confirmText:string='';

  // catalogos
  public schemaCatalog:CatalogModel[]=[];
  public categoryCatalog:CatalogModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private vwCommissionPanelService:VwCommissionPanelService,
    private catSchemaService:OtherCatalogsService,
    private catCategoryProductService:CatCategoryProductService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { 

  }
  ngOnInit() {
    
    if(this.items.length>0){
      console.log(this.items);
      this.oldSchema = this.items[0].schemaId;
      this.selectedSchemaId = Number(this.items[0].schemaId);
      this.selectedSchema.id = this.selectedSchemaId;
      this.selectedSchema.description = this.items[0].schemaDesc;
      this.commission = this.items[0].commission;
    }
    this.getCatalogs();
  }
  
  //
  updateSchema=(e:Event)=> {

    let selectText = e.target['options']
      [e.target['options'].selectedIndex].text;
    
    this.selectedSchema.id = this.selectedSchemaId;
    this.selectedSchema.description = selectText;
    this.selectedCategory=new CatalogModel();
  }
  updateCategory=()=> {}
  updateCommission=e=> this.commission=Number(e);
  toggleActive=()=> this.active=!this.active;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.schemaError()) errors.push('Necesita seleccionar un esquema.');
    if(this.categoryError()) errors.push('Necesita seleccionar una categoría.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    this.confirmText='Se modificará la configuración de Línea de Negocio=';
    this.confirmText+='<strong>'+this.items.map(it=> it.businessProductDesc)
      .filter((value, index, self)=> self.indexOf(value)===index)
      .join('</strong>, <strong>')
      .replace(/,(?=[^,]*$)/, ' y ')+'</strong>';

    this.confirmText+=', Convenio=';
    this.confirmText+='<strong>'+this.items.map(it=> it.afiliateDesc)
      .filter((value, index, self)=> self.indexOf(value)===index)
      .join('</strong>, <strong>')
      .replace(/,(?=[^,]*$)/, ' y ')+'</strong>';
    
    this.confirmText+=' y Puesto=';
    this.confirmText+='<strong>'+this.items.map(it=> it.employeeJobDesc)
      .filter((value, index, self)=> self.indexOf(value)===index)
      .join('</strong>, <strong>')
      .replace(/,(?=[^,]*$)/, ' y ')+'</strong>.';

    let strActive = "";
    if(!this.active) strActive = "  Además de <strong>DESACTIVAR la Configuración</strong>";
    
    this.confirmText+=' Con el nuevo Esquema=<strong>' + this.selectedSchema.description + "</strong>";
    this.confirmText+=' y Comisión=<strong>' + this.commission + "</strong>." + strActive + "!";

    
    this.viewStatus=2;
  }
  close=()=> this.modalService.dismissAll();

  // CONFIRMACION
  accept=()=> {
    if(this.isValid() && this.oldSchema>0) {
      this.viewStatus=0;      
      this.items.forEach(it=> {
        it.schemaId=this.selectedSchema.id;
        it.schemaDesc=this.selectedSchema.description;
        //Grupo de Asesores solamente:
        //it.productCategoryId=this.selectedSchema.id===3?this.selectedCategory.id:5;
        //it.productCategoryDesc=this.selectedSchema.id===3?this.selectedCategory.description:'N/A CATEGORIA';
        //it.commission=this.selectedSchema.id===5?this.commission:null;
        it.activeId=this.active;
      })
      // enviar informacion
      if(this.commissionGroup === 2){  //&& this.items[0].schemaId === 3
        if(this.showCommissionInput()){
          this.items[0].commission=this.commission;
        }
        console.log(">>> updateConfigsFinancing >> data=", this.items[0]);
        console.log(">>> updateConfigsFinancing >> oldSchema=", this.oldSchema);
        this.updateConfigsFinancing(this.items[0], this.oldSchema);
      }else{
        console.log(">>> updateConfigsTertia >> data=", this.items[0]);
        console.log(">>> updateConfigsTertia >> oldSchema=", this.oldSchema);
        this.updateConfigsTertia(this.items[0], this.oldSchema);
      }
    }
  }

  updateConfigsTertia=(config:VwCommissionPanelModel, oldSchema:number)=>{
    config.modifiUser = Number(localStorage.getItem('com_token'));
    this.vwCommissionPanelService.updateConfigsTertia(config, oldSchema)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La Configuración se guardó correctamente!');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ha ocurrido un error al intentar guardar la Configuración!'));
          })
        )
        .subscribe();
  }

  updateConfigsFinancing=(config:VwCommissionPanelModel, oldSchema:number)=>{
    config.modifiUser = Number(localStorage.getItem('com_token'));
    this.vwCommissionPanelService.updateConfigsFinancing(config, oldSchema)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La Configuración se guardó correctamente!');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ha ocurrido un error al intentar guardar la Configuración!'));
          })
        )
        .subscribe();
  }


  cancel=()=> this.viewStatus=1;

  // HELPERS
  schemaError=()=> !this.selectedSchema || !this.selectedSchema.id;
  showCategorySelector=()=> this.selectedSchema.id===3;
  categoryError=()=> this.selectedSchema.id===3 && (!this.selectedCategory || !this.selectedCategory.id);
  showCommissionInput=()=> this.selectedSchema.id===5;
  commissionError=()=> this.selectedSchema.id===5 && (this.commission!==0 && !this.commission);

  // INFO 
  getCatalogs=()=> {
    forkJoin(
      this.catSchemaService.getListSchemaByEmployeeJob(this.items[0].employeeJobId.toString()),
      this.catCategoryProductService.catalog()
    )
    .pipe(
      tap(([schemaResp, catResp]:[any, any])=> {
        if(schemaResp && catResp) {
          this.schemaCatalog=schemaResp.data;
          this.categoryCatalog=catResp.data;
          console.log(this.categoryCatalog)
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.close();
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}